import exame from '@/repositories/conecta-sus/parametrizacao/exameRepository'
import kitExame from '@/repositories/conecta-sus/parametrizacao/kitExameRepository'
import procedimento from '@/repositories/conecta-sus/parametrizacao/procedimentoRepository'
import procedimentoCirurgico from '@/repositories/conecta-sus/parametrizacao/procedimentoCirurgicoRepository'
import relatorioExameCadastrado from '@/repositories/conecta-sus/parametrizacao/relatorioExameCadastradoRepository'
import tabelaCid from '@/repositories/conecta-sus/parametrizacao/tabelaCidRepository'
import tabelaObm from '@/repositories/conecta-sus/parametrizacao/tabelaObmRepository'
import banners from '@/repositories/conecta-sus/parametrizacao/bannersRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/parametrizacao`

    return {
        exame: exame(baseUrl),
        banners: banners(baseUrl),
        kitExame: kitExame(baseUrl),
        procedimento: procedimento(baseUrl),
        procedimentoCirurgico: procedimentoCirurgico(baseUrl),
        relatorioExameCadastrado: relatorioExameCadastrado(baseUrl),
        tabelaCid: tabelaCid(baseUrl),
        tabelaObm: tabelaObm(baseUrl),
    }
}
